import React from 'react';
import { Helmet } from 'react-helmet-async';

// Importing Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Importing Page Components
import HeroSectionSlider from './PageComponent/HeroSectionSlider';
import BlindsCategory from './PageComponent/BlindsCategory';

function Home() {
  return (
    <div>
      <Helmet>
        <meta name="description"
          content="Callistus Blinds offers premium window blinds, curtains & operating systems. Enhance your interiors with premium-quality blinds & shades." />
        <meta name="keywords" content="window blinds, roller blinds, roman blinds, curtains, premium blinds Dubai UAE" />
        <link rel="canonical" href={process.env.REACT_APP_WEBSITE_URL} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Home" />
        <meta property="og:description"
          content="Callistus Blinds offers premium window blinds, curtains & operating systems. Enhance your interiors with premium-quality blinds & shades." />
        <meta property="og:url" content={process.env.REACT_APP_WEBSITE_URL} />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <Navbar />
      <NotificationBar />
      <HeroSectionSlider />
      <BlindsCategory />
      <Footer />
    </div>
  );
}

export default Home;